import { useCallback } from 'react';
import { toast as hotToast } from 'react-hot-toast';

type ToastTypes = 'error' | 'success' | 'warning';

export default function useToast() {
  const toast = useCallback(
    (message: string, type: ToastTypes = 'success', duration?: number) => {
      const position =
        window.innerWidth >= 768 ? 'bottom-center' : 'top-center';
      switch (type) {
        case 'error':
          hotToast.error(message, {
            position,
            ...(duration !== undefined && { duration }),
          });
          break;
        case 'success':
          hotToast.success(message, {
            position,
            ...(duration !== undefined && { duration }),
          });
          break;
        case 'warning':
          hotToast(message, {
            position,
            icon: '⚠️',
            duration: duration ?? 6000,
          });
          break;
        default:
          break;
      }
    },
    [],
  );

  return { toast };
}
